import { render, staticRenderFns } from "./FilesPage.vue?vue&type=template&id=be21acc6&scoped=true&"
import script from "./FilesPage.vue?vue&type=script&lang=ts&"
export * from "./FilesPage.vue?vue&type=script&lang=ts&"
import style0 from "./FilesPage.vue?vue&type=style&index=0&id=be21acc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be21acc6",
  null
  
)

export default component.exports